var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 69.002,
    viewBox: "0 0 55 69.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x35_6",
    transform: "translate(-5.435 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11785",
    "data-name": "Path 11785",
    d: "M57.445,14.328l-9.517-8.8A9.223,9.223,0,0,0,41.546,3H14.836a9.423,9.423,0,0,0-9.4,9.4V62.6a9.424,9.424,0,0,0,9.4,9.4h36.2a9.424,9.424,0,0,0,9.4-9.4V21.228a9.484,9.484,0,0,0-2.99-6.9Zm-33.9,12.305c7.773-7.773,7.5-7.541,7.791-7.734a2.848,2.848,0,0,1,1.581-.489h.029a2.953,2.953,0,0,1,2.013.834l7.36,7.389a2.867,2.867,0,0,1-4.054,4.054l-2.444-2.444V38.392a2.875,2.875,0,0,1-5.75,0V28.243L27.6,30.716a2.877,2.877,0,0,1-4.054-4.083ZM44.076,56.591H21.794a2.875,2.875,0,1,1,0-5.75H44.076a2.875,2.875,0,1,1,0,5.75Z",
    transform: "translate(0)",
    fill: "#df9426"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file_icon.19f3bef5346c1d619df02c76c806df0e.svg";
export { ForwardRef as ReactComponent };